import { render, staticRenderFns } from "./LavLomStatusList.vue?vue&type=template&id=3b1aba7f"
import script from "./LavLomStatusList.vue?vue&type=script&lang=js"
export * from "./LavLomStatusList.vue?vue&type=script&lang=js"
import style0 from "./LavLomStatusList.vue?vue&type=style&index=0&id=3b1aba7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports